import { LATINA_LIST } from '../../constants/latina-country';
import { world } from '../../languages';
import { AVAILABLE_WORLDS, WORLD_GROUPS } from '../../languages/constants';
import { getIsLowestPrice } from './get-is-lowest-price';

const isSaleAllowed = (material: Material, countryCode?: string) => {
    const isLatamOnEsWorld = Boolean(world === AVAILABLE_WORLDS.ES && countryCode && LATINA_LIST.includes(countryCode));

    if (isLatamOnEsWorld) {
        return true;
    }

    const isEuropeanWorld = WORLD_GROUPS.EU_AND_EEA.includes(world);

    return Boolean(!isEuropeanWorld || getIsLowestPrice(material));
};

export default isSaleAllowed;
